export default __webpack_public_path__ + "static/media/SG-DarkBlue-0005.e1851c70.png";